import React from 'react';
import { motion } from 'framer-motion';
import { ChevronRight } from 'lucide-react';

const AdminPageHeader = ({ 
  title, 
  subtitle, 
  actions,
  breadcrumbs,
  className = '' 
}) => {
  return (
    <motion.div 
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      className={`admin-page-header ${className}`}
    >
      {breadcrumbs && (
        <div className="admin-breadcrumbs">
          {breadcrumbs.map((crumb, index) => (
            <React.Fragment key={index}>
              {index > 0 && <ChevronRight className="admin-breadcrumb-separator" />}
              {crumb.href ? (
                <a href={crumb.href} className="admin-breadcrumb-link">
                  {crumb.label}
                </a>
              ) : (
                <span className={`admin-breadcrumb-item ${index === breadcrumbs.length - 1 ? 'admin-breadcrumb-current' : ''}`}>
                  {crumb.label}
                </span>
              )}
            </React.Fragment>
          ))}
        </div>
      )}
      
      <div className="admin-page-header-content">
        <div className="admin-page-header-left">
          <h1 className="admin-page-title">{title}</h1>
          {subtitle && <p className="admin-page-subtitle">{subtitle}</p>}
        </div>
        {actions && (
          <div className="admin-page-header-actions">
            {Array.isArray(actions) ? (
              actions.map((action, index) => (
                <React.Fragment key={index}>{action}</React.Fragment>
              ))
            ) : (
              actions
            )}
          </div>
        )}
      </div>
    </motion.div>
  );
};

export default AdminPageHeader;

